import { useState } from "react";
import { LEAGUE_LOGOS } from "../../constants/leagueLogos";

// Official league mark (see constants/leagueLogos.js for the verified source per league). If the
// logo fails to load, falls back to a plain neutral circle rather than a text abbreviation --
// the league's full label is always rendered right next to this badge by the caller, so a
// duplicated abbreviation (e.g. "CPB" badge beside a "CPBL" label) would just look redundant.
export const LeagueLogo = ({ code, label, size = 20, testId }) => {
  const [failed, setFailed] = useState(false);
  const url = LEAGUE_LOGOS[code];
  const showFallback = !url || failed;

  return (
    <span
      data-testid={testId}
      title={label || code}
      style={{ height: size, width: size }}
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-white/90 p-0.5"
    >
      {showFallback ? (
        <span className="h-1.5 w-1.5 rounded-full bg-zinc-500" />
      ) : (
        <img src={url} alt={`${label || code} logo`} className="h-full w-full object-contain" onError={() => setFailed(true)} />
      )}
    </span>
  );
};

